import * as amplitude from '@amplitude/analytics-browser';
import { ExperimentClient } from '@amplitude/experiment-js-client';
import type { ExperimentConfig } from '@amplitude/experiment-js-client';

import { getUiConfig } from '@/config/client/getUiConfig';
import { getXid } from '@/features/auth/client';

let experimentClient: ExperimentClient | null = null;

function getExperimentClient(): ExperimentClient {
  if (!experimentClient) {
    const uiConfig = getUiConfig();

    const config: ExperimentConfig = {
      fetchOnStart: true,
      debug: uiConfig.environment === 'stage',
    };

    experimentClient = new ExperimentClient(uiConfig.amplitudeApiKey, config);
  }

  return experimentClient;
}

export async function initializeAmplitude(): Promise<void> {
  const client = getExperimentClient();
  const xid = await getXid();
  const uiConfig = getUiConfig();

  amplitude.init(uiConfig.amplitudeApiKey, {
    deviceId: xid,
    autocapture: false,
    defaultTracking: false,
  });

  const user = {
    device_id: xid,
  };

  await client.start(user);

  window.amplitude = {
    identity: amplitude.getIdentity(),
    optOut: amplitude.getOptOut(),
    sessionId: amplitude.getSessionId(),
    userId: amplitude.getUserId(),
  };
}

export function getExperimentVariant(key: string, fallback?: string): unknown {
  return getExperimentClient().variant(key, fallback).value;
}

export default getExperimentClient();
